/**
 * @Author: WeiZisen
 * @Date: 2021-03-17 15:01:58
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-03-17 15:02:24
 * @Description: 请输入一段描述
 * @FilePath: \Vue_RebarProcess\src\validate\system\obs-define.js
 */
export let rules = {
  name: [{ required: true, message: '请填写OBS名称', trigger: 'blur' }],
  description: [{ required: true, message: '请填写描述', trigger: 'blur' }],
}
